import { type Command } from '@telespot/core';

/**
 * Details for {@link AddUser}
 *
 * @group Organizations
 * @category Payloads
 */
export interface AddUserDetails {
  /**
   * User's email or username
   */
  emailOrUsername: string;
  /**
   * Organization's ID
   */
  organizationId: string;

  password?: string;
}

/**
 * Command registration token for {@link AddUser}
 *
 * @group Organizations
 * @category Tokens
 */
export const ADD_USER = 'organization:addUser';

/**
 * Adds a user to an organization.
 * The organization should exist, if it does not this command will fail with a {@link AffiliationError.ORG_NOT_FOUND} error.
 * In case a user does not exist, it is created.
 * Only one user to organization affiliation is allowed, so if the user belongs a {@link AffiliationError.USER_BELONGS} error is thrown.
 *
 * @group Organizations
 * @category Commands
 */
export class AddUser implements Command<typeof ADD_USER, AddUserDetails> {
  public readonly name = ADD_USER;

  constructor(public readonly details: Readonly<AddUserDetails>) {}
}
